import React, { useState } from 'react';

import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import ViewGraph from '../results/view-graph';
import ButtonGroup from 'components/button-group';
import { GraphData, Summary } from 'views/bluviu-nutrition/features/scenarios/types/scenario-result.type';
import CompareTable from './compare-table';

type CompareProps = {
  selectedGraphData: GraphData[];
  selectedFeedPlans: Summary[];
};

const ButtonGroupStyle = {
  position: 'absolute',
  left: '43%',
  top: 30,
};

const CompareDialog: React.FC<CompareProps> = ({ selectedGraphData, selectedFeedPlans }) => {
  const intl = useIntl();
  const [isTable, setIsTable] = useState(false);
  const PAGE_NAME_ID = 'bluViuNutrition.viewScenarioResultGt2.compareDialog';

  return (
    <>
      <Box display={'flex'} justifyContent={'center'} sx={ButtonGroupStyle}>
        <ButtonGroup
          value={'group'}
          buttons={[
            { label: intl.formatMessage({ id: `${PAGE_NAME_ID}.table` }), value: 'left', state: false },
            {
              label: intl.formatMessage({ id: `${PAGE_NAME_ID}.graph` }),
              value: 'center',
              state: true,
            },
          ]}
          handleClick={(e) => setIsTable(e as boolean)}
        />
      </Box>
      {!isTable ? <CompareTable selectedFeedPlans={selectedFeedPlans} /> : <ViewGraph graphData={selectedGraphData} />}
    </>
  );
};

export default CompareDialog;
